import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left space-y-1" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "flex flex-row text-left space-x-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Imagem", -1)
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.anchorReply())),
    class: "flex justify-between items-center cursor-pointer"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getUserName), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          name: "Camera",
          size: "18"
        }),
        _hoisted_4
      ])
    ]),
    _createElementVNode("img", {
      alt: "Respondendo a imagem",
      src: _ctx.messageImage,
      class: "rounded w-16 h-16"
    }, null, 8, _hoisted_5)
  ]))
}